module.exports = __webpack_public_path__ + "static/media/long-arrow-alt-up.3a369892.svg";